"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareDays = exports.calculateNumberOfMonths = exports.buildCalendarStateObject = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _constants = require("./constants");
const buildCalendarStateObject = function (startDate, endDate) {
  let focusedInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    startDate: new Date((0, _dayjs.default)(startDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    endDate: new Date((0, _dayjs.default)(endDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    focusedInput
  };
};
exports.buildCalendarStateObject = buildCalendarStateObject;
const calculateNumberOfMonths = (date1, date2) => {
  const formattedDate2 = (0, _dayjs.default)(date2);
  const formattedDate1 = (0, _dayjs.default)(date1);
  return formattedDate1.get('month') - formattedDate2.get('month') + (formattedDate1.get('year') - formattedDate2.get('year')) * 12 + 1;
};
exports.calculateNumberOfMonths = calculateNumberOfMonths;
const compareDays = (date1, date2) => (0, _dayjs.default)(date1).isSame((0, _dayjs.default)(date2), 'day');
exports.compareDays = compareDays;